import { Routes, Route, Navigate } from 'react-router-dom';
import Integrations, {
  RequestsRoutes,
  DistributionRoutes,
  WorkspacesRoutes,
  AuditRoutes,
} from '../domains/integrations';

/**
 * Studio-level routes for Admin Studio.
 *
 * Paths are RELATIVE to the parent route that mounts AdminStudioApp:
 *   - Shell:      <Route path="admin-studio/*">
 *   - Standalone: <Route path="admin-studio/*"> in main.jsx
 *
 * `integrations` is the first domain; others (requests, distribution, audit…)
 * mount here as their stories land.
 */
function AdminStudioRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="integrations" replace />} />
      <Route path="integrations/*" element={<Integrations />} />
      <Route path="requests/*" element={<RequestsRoutes />} />
      <Route path="distribution/*" element={<DistributionRoutes />} />
      <Route path="workspaces/*" element={<WorkspacesRoutes />} />
      <Route path="audit/*" element={<AuditRoutes />} />
      <Route path="*" element={<Navigate to="integrations" replace />} />
    </Routes>
  );
}

export default AdminStudioRoutes;
